//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
let d=[[],[[["object"],"SetAttributesToObjects",{},1,1],[["object"],"CopyAttributesToPart",{},1,1],[["bCreate","feat_builder"],"SetAttributesToObjects1",{},2,1],[["bCreate","feat_builder"],"CopyAttributesToObjects",{},2,0],[["bCreate","feat_builder"],"CopyAttributesToPart1",{},2,0],[["object"],"SetAttributesToProxy",{},1,0],[[],"GetAttributeProxy",{R_:{proxy:"NXObject"}},0,0],[["feat_builder"],"SetAttributeToProxyFromBuilder",{},1,0],[["feat_builder"],"GetContextAttributeFromNamesBuilder",{},1,0],[["objects"],"SetAttributeToObjects",{},1,0],[["featureTag"],"UpdateContextName",{},1,0],[["featureTag"],"UpdateContextNameAndRenameFeature",{},1,0]],[]];
SPLM.Features.ShipDesign.ShipAttributeHolder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ShipAttributeHolder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;